import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { ThemeLayoutService } from '@app/core/services/theme-layout.service';
import { MatIconModule } from '@angular/material/icon';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [
    MatIconModule,
    NgOptimizedImage
  ],
  template: `
   <footer  class="footer">
      <div class="footer__wrapper">
        <div class="footer__left">
          <a href="https://bind.com.mx/" target="_blank" rel="noopener noreferrer" aria-label="Landing Page de Bind ERP">
            <div class="footer__logo-box">
            <img
              [ngSrc]="logoUrl()"
              alt="Minnt Solutions"
              class="footer__logo"
              fill
              priority="true"
            />
            </div>
          </a>
          <p class="footer__text">© Minnt Solutions SAPI de CV. Todos los derechos reservados.</p>
        </div>

        <div id="step-social" class="footer__social">
          <a href="https://www.facebook.com/BindMexico" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <mat-icon svgIcon="facebook"></mat-icon>
          </a>
          <a href="https://www.tiktok.com/@binderpmex" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
            <mat-icon svgIcon="tiktok"></mat-icon>
          </a>
          <a href="https://www.instagram.com/BindMexico" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <mat-icon svgIcon="instagram"></mat-icon>
          </a>
          <a href="https://www.linkedin.com/company/bindmexico" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <mat-icon svgIcon="linkedin"></mat-icon>
          </a>
          <a href="https://www.youtube.com/c/BindMexico" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <mat-icon svgIcon="youtube"></mat-icon>
          </a>
          <a href="https://x.com/BindERPMX" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
            <mat-icon svgIcon="x"></mat-icon>
          </a>
        </div>
      </div>
    </footer>
  `,
  styles: [
    `
    .footer {
      position: relative;
      padding: 15px 0;
      z-index: 1024;

      a {
        color: var(--accent-900);
        transition: color 0.2s ease;
        &:hover {
          color: var(--primary-500);
        }
      }

      &__wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 80px 0px 30px;
      }

      &__left {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      &__logo-box {
        position: relative;
        width: 48px;
        height: 48px;
      }

      &__logo {
        object-fit: contain;
        height: auto;
      }

      &__text {
        margin: 0;
      }

      &__social {
        display: flex;
        align-items: center;
        gap: 0.75rem;

        a {
          font-size: 16px;
          width: 36px;
          height: 36px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background-color: var(--accent-200);
          transition: all 0.2s ease;

          &:hover {
            background-color: var(--primary-500);
            color: white;
            transform: translateY(-3px);
          }
        }
      }

      @media (max-width: 768px) {
        &__wrapper {
          flex-direction: column;
          align-items: center;
          padding: 0 15px;
          gap: 1rem;
        }
      }
    }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  themeService = inject(ThemeLayoutService);
  logoUrl: Signal<string> = computed(() =>
    this.themeService.theme() === 'dark' ? 'assets/images/logo-white.svg' : 'assets/images/logo-dark.svg'
  );
}
